import React, {useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnUnderLine from '../../../Shared/Buttons/BtnUnderLine';
import ProviderManager from '../../../../provider/providerManager';
import MapWrapper from '../../../Shared/MapWrapper/MapWrapper';
import LightIcon from '../assets/lightIcon.svg';
import Property from '@episerver/spa-core/Components/Property';
import {PageView, ErrorView} from '../Shared/Constants';
import Image from 'app/Components/Shared/Image/image';
import {Container, Row, Col} from 'reactstrap';

const ShowLocation = ({data, context, guid, changeStep, setCurrentError, coords, geoError, setCoords, setGeoError}) => {
  let imageLightSrc = LightIcon;
  let btnText = data?.secondPageButton?.value ? data?.secondPageButton?.value : `שליחת מיקום לנציג ${window.Config.brand_Name_HE}`;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (geoError) {
      setCurrentError(ErrorView.General);
      changeStep(PageView.ErrorPopUp);
    }
  }, [geoError, setCurrentError, changeStep]);

  const handleReload = () => {
    setCoords(null);
    setGeoError(null);
    changeStep('');
  };
  const handleSubmit = async (e) => {
    if (!coords) {
      return;
    }
    changeStep(PageView.Loader);
    e.preventDefault();
    try {
      const result = await ProviderManager.getProviderData('postClientLocationData', [guid, coords.long, coords.lat]);
      if (result.Body) {
        changeStep(PageView.Completed);
      } else {
        setCurrentError(ErrorView.SaveDB);
        changeStep(PageView.ErrorPopUp);
      }
    } catch (e) {
      setCurrentError(ErrorView.SaveDB);
      changeStep(PageView.ErrorPopUp);
    }
  };

  var showLocation = coords && (
    <div>
      <MapWrapper latitude={coords.lat} longitude={coords.long} accuracy={coords.accuracy} />
    </div>
  );
  return (
    <>
      <Container>
        <Row className='justify-content-center'>
          <Col>
            <Property className='show-location__tittle' context={context} iContent={data} field='addressApprovalTittle' />
          </Col>
        </Row>
        <Row className='justify-content-center'>
          <Property className='show-location__sub-tittle' context={context} iContent={data} field='addressApprovalSubTittle' />
        </Row>
        <Row className='justify-content-center'>
          <div className='show-location__notice'>
            <Image src={imageLightSrc} alt='פעמון' width={100} height={100} />
            <Property context={context} iContent={data} field='textInfoAboutLink' />
          </div>
        </Row>
        <Row className='justify-content-center'>
          <div className='show-location__map'>{showLocation}</div>
        </Row>
        <Row className='justify-content-center'>
          <Property className='show-location__privacy-policy' context={context} iContent={data} field='textApprovePostLocation' />
        </Row>
        <Row className='justify-content-center'>
          <div className='show-location__button'>
            <BtnUnderLine text='בואו ננסה שוב' onClick={() => handleReload()} />
            <BtnSubmit text={btnText} onclick={(e) => handleSubmit(e)} />
          </div>
        </Row>
      </Container>
    </>
  );
};
export default ShowLocation;
